function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Button from '../../Buttons/Button/Button';
import Dropzone from 'dropzone';
import I18n, { formatI18n } from '../../I18n/I18n/I18n';
import Modal from '../../Modal/Modal/Modal';
import ModalBody from '../../Modal/ModalBody/ModalBody';
import ModalFooter from '../../Modal/ModalFooter/ModalFooter';
import React from 'react';
import cs from 'classnames';
import en from './locales/FileInput.en.json';
import styles from './FileInput.module.scss';
import withInputContainer from '../withInputContainer/withInputContainer';
import compose from '../../utils/compose';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import uuid from '../../utils/uuid';
import httpOptions from '../../utils/http/httpOptions';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import FilesList from './FilesList/FilesList';
import { injectIntl } from 'react-intl';
import ThemeContext from '../../ThemeContext';
import getLabelId from '../getLabelId';
var MESSAGE_PREFIX = '@dm/components.file-input';
var messages = normalizeLocaleData(en, MESSAGE_PREFIX);
var messageId = function messageId(id) {
  return "".concat(MESSAGE_PREFIX, ".").concat(id);
};
var ACTIONS = {
  ADD: 'ADD_FILE',
  SUCCESS: 'FILE_SUCCESS',
  REMOVE: 'REMOVE_FILE',
  ERROR: 'FILE_ERROR',
  PROGRESS: 'FILE_PROGRESS'
};
var BASE_FILE_WHITE_LIST = '.html,text/html,.tsv,text/tab-separated-values,.csv,text/csv,text/x-csv,application/x-csv,text/plain' +
//text
',text/comma-separated-values,text/x-comma-separated-values,.richtext,.rtf,.txt' + ',text/markdown,.md' + ',.apng,.gif,.heic,.heif,.jpeg,.jpg,.jxl,.jxs,.png,.webp, image/svg+xml' +
//image
',.mp4,.doc,application/vnd.openxmlformats-officedocument.wordprocessingml.document' + ',application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' + ',.pdf,.xml,.zip,.vnd.ms-powerpoint,.vnd.ms-excel,application/vnd.ms-excel,application/csv' +
//application
',application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet,application/epub+zip' + ',application/vnd.ms-powerpoint,.pptx,application/vnd.oasis.opendocument.presentation,.odp' + ',.h266,.h265,.av1,.mpeg,.VP8,.VP9' +
//video
',.mp4,.mpeg'; //audio

var BLACK_LIST = ['.exe', '.asp', '.php', '.jsp', '.rar'];
var isExtensionBlocked = function isExtensionBlocked(fileName) {
  var returnedExt = BLACK_LIST.find(function (extension) {
    return fileName.endsWith(extension);
  });
  return returnedExt !== undefined;
};
var valueToFiles = function valueToFiles(value) {
  var files = value || [];
  return files.map(valueToFile);
};
var valueToFile = function valueToFile(value) {
  return {
    accepted: true,
    location: value.location,
    name: value.name,
    size: value.size,
    status: 'success',
    type: value.mimeType,
    upload: {
      uuid: uuid()
    }
  };
};
var BaseFileInput = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseFileInput, _React$Component);
  function BaseFileInput(props) {
    var _this;
    _classCallCheck(this, BaseFileInput);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseFileInput).call(this, props));
    _this.initializeDropzone = function () {
      var _this$props = _this.props,
        url = _this$props.url,
        disabled = _this$props.disabled;
      var invalid = disabled || !url || !_this.dropzoneRef.current;
      var initialized = _this.dropzone && _this.dropzone.element === _this.dropzoneRef.current; // this happens when hitting max files then deleting a file
      if (!invalid && !initialized) {
        var _this$props2 = _this.props,
          _this$props2$maxFileN = _this$props2.maxFileNameLength,
          maxFileNameLength = _this$props2$maxFileN === void 0 ? 255 : _this$props2$maxFileN,
          _this$props2$maxFileS = _this$props2.maxFileSize,
          maxFileSize = _this$props2$maxFileS === void 0 ? 1024 : _this$props2$maxFileS,
          _this$props2$maxFiles = _this$props2.maxFiles,
          maxFiles = _this$props2$maxFiles === void 0 ? null : _this$props2$maxFiles,
          acceptedFiles = _this$props2.acceptedFiles,
          intl = _this$props2.intl;
        var files = _this.state.files;
        var _httpOptions$getOptio = httpOptions.getOptions().headers,
          x = _httpOptions$getOptio['Content-Type'],
          headers = _objectWithoutProperties(_httpOptions$getOptio, ["Content-Type"]);
        _this.dropzone = new Dropzone(_this.dropzoneRef.current, {
          url: url,
          maxFiles: maxFiles,
          maxFilesize: maxFileSize,
          createImageThumbnails: false,
          previewTemplate: '<span></span>',
          timeout: 0,
          // No Timeout
          headers: headers,
          acceptedFiles: acceptedFiles,
          accept: function accept(file, done) {
            if (isExtensionBlocked(file.name)) {
              done(formatI18n(intl, {
                id: messageId('file-type-not-supported'),
                values: {
                  limit: maxFileNameLength
                }
              }));
            }
            if (maxFileNameLength && file.name.length > maxFileNameLength) {
              done(formatI18n(intl, {
                id: messageId('filename-limit-exceeded'),
                values: {
                  limit: maxFileNameLength
                }
              }));
            } else {
              done();
            }
          },
          dictInvalidFileType: {
            code: 415,
            message: formatI18n(intl, messageId('dropzone.dictInvalidFileType'))
          },
          // i18n-izing Dropzone's defaults
          dictDefaultMessage: formatI18n(intl, messageId('dropzone.dictDefaultMessage')),
          dictFallbackMessage: formatI18n(intl, messageId('dropzone.dictFallbackMessage')),
          dictFallbackText: formatI18n(intl, messageId('dropzone.dictFallbackText')),
          // dictFileTooBig: formatI18n(intl, messageId('dropzone.dictFileTooBig')),
          // dictResponseError: formatI18n(
          // 	intl,
          // 	messageId('dropzone.dictResponseError')
          // ),
          dictCancelUpload: formatI18n(intl, messageId('dropzone.dictCancelUpload')),
          dictUploadCanceled: formatI18n(intl, messageId('dropzone.dictUploadCanceled')),
          dictCancelUploadConfirmation: formatI18n(intl, messageId('dropzone.dictCancelUploadConfirmation')),
          dictRemoveFile: formatI18n(intl, messageId('dropzone.dictRemoveFile')),
          dictMaxFilesExceeded: formatI18n(intl, messageId('dropzone.dictMaxFilesExceeded'))
        });
        _this.dropzone.on('addedfile', _this.onDZAddedFile);
        _this.dropzone.on('error', _this.onDZError);
        _this.dropzone.on('maxfilesexceeded', _this.onDZMaxFilesExceeded);
        _this.dropzone.on('maxfilesreached', _this.onDZMaxFilesReached);
        _this.dropzone.on('removedfile', _this.onDZRemovedFile);
        _this.dropzone.on('success', _this.onDZSuccess);
        _this.dropzone.on('uploadprogress', _this.onDZUploadProgress);
        var dzFiles = _this.dropzone.files;
        files.forEach(function (file) {
          return dzFiles.push(file);
        });
        if (maxFiles && maxFiles === dzFiles.length) {
          _this.onDZMaxFilesReached();
        }
      }
    };
    _this.onClickDelete = function (file) {
      _this.setState({
        deleteFile: file
      });
    };
    _this.onClickCancelDelete = function () {
      _this.setState({
        deleteFile: false
      });
    };
    _this.onClickPerformDelete = function () {
      _this.dropzone.removeFile(_this.state.deleteFile);
      _this.onClickCancelDelete();
    };
    _this.onDZAddedFile = function (file) {
      if (file) {
        if (_this.props.maxFiles === 1 && _this.state.files.length) {
          var files = [file];
          _this.dropzone.removeFile(_this.state.files[0]);
          _this.setState({
            files: files
          });
          _this.onChange(files, ACTIONS.ADD);
        } else {
          _this.addFile(file);
        }
      }
    };
    _this.onDZError = function (file, errorMessage, xhr) {
      file.errorMessage = errorMessage;
      _this.updateFile(file, ACTIONS.ERROR);
      _this.props.onError && _this.props.onError(file, xhr);
    };
    _this.onDZMaxFilesExceeded = function (file) {
      _this.removeFile(file, 'limit-exceeded');
    };
    _this.onDZMaxFilesReached = function () {
      if (_this.props.maxFiles > 1) {
        _this.setState({
          errorMessageKey: 'limit-reached'
        });
      }
    };
    _this.onDZRemovedFile = function (file) {
      _this.removeFile(file);
    };
    _this.onDZSuccess = function (file) {
      file.location = file.xhr.getResponseHeader('Location');
      _this.updateFile(file, ACTIONS.SUCCESS);
      _this.props.onSuccess && _this.props.onSuccess(file.xhr);
    };
    _this.onDZUploadProgress = function (file) {
      _this.updateFile(file, ACTIONS.PROGRESS);
      _this.props.onProgress && _this.props.onProgress(file);
    };
    _this.onCancel = function (file) {
      _this.dropzone.removeFile(file);
    };
    _this.addFile = function (file) {
      var files = _this.state.files.concat([file]);
      _this.setState({
        files: files
      });
      _this.onChange(files, ACTIONS.ADD);
    };
    _this.removeFile = function (file, errorMessageKey) {
      var files = _this.state.files.reduce(function (acc, val) {
        if (val.upload.uuid !== file.upload.uuid) {
          acc.push(val);
        }
        return acc;
      }, []);
      _this.setState({
        files: files,
        errorMessageKey: errorMessageKey,
        announceText: formatI18n(_this.props.intl, {
          id: messageId('removed'),
          values: {
            fileName: file.name
          }
        })
      }, function () {
        var ref = _this.dropzoneRef.current;
        if (ref) {
          ref.focus();
        }
      });
      _this.onChange(files, ACTIONS.REMOVE);
    };
    _this.updateFile = function (file, action) {
      var files = _this.state.files.reduce(function (acc, val) {
        acc.push(val.upload.uuid === file.upload.uuid ? file : val);
        return acc;
      }, []);
      _this.setState({
        files: files
      });
      if (action === ACTIONS.SUCCESS) {
        _this.setState({
          announceText: formatI18n(_this.props.intl, {
            id: messageId('complete'),
            values: {
              fileName: file.name
            }
          })
        });
      }
      _this.onChange(files, action);
    };
    _this.onChange = function (files, action) {
      var _this$props3 = _this.props,
        onBlur = _this$props3.onBlur,
        onChange = _this$props3.onChange;
      if (action === ACTIONS.SUCCESS || action === ACTIONS.REMOVE) {
        onChange && onChange(files.map(_this.fileToValue), action);
      }
      setTimeout(function () {
        onBlur && onBlur();
      }, 100);
    };
    _this.fileToValue = function (file) {
      return {
        location: file.location,
        size: file.size,
        errorMessage: file.errorMessage,
        mimeType: file.type,
        name: file.name
      };
    };
    _this.dropzoneRef = React.createRef();
    _this.state = {
      deleteFile: false,
      files: valueToFiles(props.value),
      announceText: ''
    };
    return _this;
  }
  _createClass(BaseFileInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeDropzone();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.initializeDropzone();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        disabled = _this$props4.disabled,
        maxFiles = _this$props4.maxFiles,
        readonly = _this$props4.readonly,
        size = _this$props4.size,
        acceptedFilesDisplay = _this$props4.acceptedFilesDisplay,
        id = _this$props4.id;
      var _this$state = this.state,
        deleteFile = _this$state.deleteFile,
        errorMessageKey = _this$state.errorMessageKey,
        files = _this$state.files;
      var showErrorMessages = errorMessageKey && maxFiles > 1;
      var showDisabled = readonly || showErrorMessages;
      var uploadI18nKey = maxFiles === 1 && files.length >= 1 ? 'replace' : 'upload';
      var theme = this.context;
      return /*#__PURE__*/React.createElement("div", {
        className: cs(styles.group, styles[theme])
      }, !disabled && (showDisabled ? /*#__PURE__*/React.createElement("div", {
        className: cs(styles.container, styles['container--readonly'])
      }, showErrorMessages ? /*#__PURE__*/React.createElement(I18n, {
        i18n: {
          id: messageId(errorMessageKey),
          values: {
            limit: maxFiles
          }
        }
      }) : /*#__PURE__*/React.createElement(I18n, {
        i18n: messageId('upload-readonly')
      })) : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: cs(styles.container, 'auto-upload-file-button', styles['container--active']),
        ref: this.dropzoneRef,
        "aria-describedby": id ? getLabelId(id) : undefined
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: {
          id: messageId(acceptedFilesDisplay ? "".concat(uploadI18nKey, "-whitelist") : "".concat(uploadI18nKey, "-default")),
          values: {
            fileTypes: acceptedFilesDisplay,
            maxFiles: maxFiles
          }
        }
      }))), /*#__PURE__*/React.createElement("div", {
        "aria-live": "polite"
      }, /*#__PURE__*/React.createElement(FilesList, {
        onCancel: this.onCancel,
        onDelete: this.onClickDelete,
        readonly: readonly,
        size: size,
        disabled: disabled,
        files: files
      })), /*#__PURE__*/React.createElement("div", {
        "aria-live": "polite",
        "aria-atomic": true,
        className: "assistive-text"
      }, this.state.announceText), !disabled && /*#__PURE__*/React.createElement(Modal, {
        mounted: !!deleteFile,
        titleText: messageId('confirm-title'),
        maxWidth: 480,
        includeCloseX: false
      }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(I18n, {
        i18n: messageId('confirm')
      })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement("div", {
        className: styles['delete__footer']
      }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: "ripple"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "auto-modal-footer-button-cancel",
        onClick: this.onClickCancelDelete
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: messageId('cancel')
      })), /*#__PURE__*/React.createElement(Button, {
        className: "auto-modal-footer-button-confirm",
        modifier: "delete",
        onClick: this.onClickPerformDelete
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: messageId('delete')
      })))))));
    }
  }]);
  return BaseFileInput;
}(React.Component);
BaseFileInput.contextType = ThemeContext;
export var FileInput = compose(withAdditionalIntl({
  messages: messages,
  path: '_PROPOSED_/FileInput/locales/FileInput',
  namespace: MESSAGE_PREFIX
}), injectIntl)(BaseFileInput);
export default withInputContainer({
  type: 'file'
})(FileInput);